import { Icon } from '@iconify/react';
import { isIPenPlatformDomainEntity } from '@ipen-portal/plugin-common';
import { makeEntityContentWithToolbar } from '@ipen-portal/plugin-layout-react';

import { LifecycleFilter } from '../../components/LifecycleFilter';
import { CoreProcessFilter } from '../SolutionListPage/components/DomainFilter';
import { DataProductAlignmentFilter } from './components/DataProductAlignmentFilter';

export const DataProductListEntityContent = makeEntityContentWithToolbar({
  name: 'DataProductListEntityContent',
  params: {
    filter: isIPenPlatformDomainEntity,
    icon: <Icon icon="carbon:3d-print-mesh" />,
    loader: async () =>
      import('./components/DataProductList').then(m => <m.DataProductList />),
    path: '/data-products',
    title: 'Data Products',
    toolbarProps: {
      creationTemplateRef: 'ipen-data-product-doc',
      filter: [CoreProcessFilter, LifecycleFilter, DataProductAlignmentFilter],
    },
    wrapperProps: {
      kindFilter: 'component',
      typeFilter: 'data-product',
    },
  },
});
